import React, { memo } from 'react';
import '@atlaskit/css-reset';
import PageAppInitialisationAnalytics from '@atlassian/jira-common-analytics-page-app-initialisation/src/index.tsx';
import QueryParamAdapter from '@atlassian/jira-project-directories-components/src/query-param-adapter/index.tsx';
import {
	RedirectToArchivedPage,
	isProjectArchivedCondition,
} from '@atlassian/jira-redirect-archived-project/src/ui/index.tsx';
import { projectsComponentsResource } from '@atlassian/jira-router-resources-project-components/src/services/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { useRouter, useResource } from '@atlassian/react-resource-router';
import Components from './view/index.tsx';

const ProjectComponents = (): React.JSX.Element => {
	const [{ match, location }] = useRouter();
	const prefetchResult = useResource(projectsComponentsResource);
	const projectContext = useResource(projectContextResource);
	const tenantContext = useTenantContext();

	const { projectKey } = match.params;

	if (isProjectArchivedCondition(projectContext.data)) {
		return <RedirectToArchivedPage />;
	}

	return (
		<>
			<MarkProductStart />
			<PageAppInitialisationAnalytics
				appNameSuffixForV2Event="project.components"
				appNameForV3OperationalEvent="componentsProject"
			/>
			<AuthenticationCheck>
				{projectKey && projectContext ? (
					<QueryParamAdapter location={location}>
						{({ query, onQueryChanged }) => (
							<Components
								projectContext={projectContext}
								tenantContext={tenantContext}
								prefetchResult={{ ...prefetchResult }}
								query={query}
								onQueryChanged={onQueryChanged}
							/>
						)}
					</QueryParamAdapter>
				) : null}
			</AuthenticationCheck>
		</>
	);
};

export default memo(ProjectComponents);
